const url = import.meta.env.VITE_API_URL;

export default url